export default __webpack_public_path__ + "static/media/logo_makesoft.6e91093f.png";